import Vue from 'vue'
import { ItemService } from '@/services'
import apiMedia from './api'
import { Message } from 'element-ui'

const PAGE_SIZE = 50

const namespaced = true

const state = {
  all: {
    files: [],
    nextToken: undefined,
    timestamp: undefined,
    busy: false
  },
  audio: {
    files: [],
    nextToken: undefined,
    timestamp: undefined,
    busy: false
  },
  photo: {
    files: [],
    nextToken: undefined,
    timestamp: undefined,
    busy: false
  },
  video: {
    files: [],
    nextToken: undefined,
    timestamp: undefined,
    busy: false
  },
  activeTab: 'all'
}

const getters = {
  activeTab: state => state.activeTab,
  mediaBusy: state => state[state.activeTab].busy,
  files: state => type => state[type].files,
  hasNextToken: state => type => !!state[type].nextToken
}

const actions = {
  activateTab ({ commit }, tab) {
    commit('setActiveTab', tab)
  },
  getAllMediaFiles ({ state, dispatch }) {
    const tabs = ['all', 'audio', 'photo', 'video']
    tabs.forEach((tab) => {
      if (!state[tab].busy && !state[tab].files.length) dispatch('getFiles', { tab })
    })
  },
  getFiles ({ state, commit, dispatch }, { tab }) {
    if (state[tab].busy) return

    commit('setBusy', { tab, busy: true })
    const token = state[tab].nextToken
    // media getter require to send no 'type' param for getting all types
    const type = tab === 'all' ? undefined : tab
    apiMedia
      .getMediaFiles({ type, nextToken: token, pageSize: PAGE_SIZE })
      .then(ItemService.decodeItems)
      .then(({ items, nextToken }) => {
        items.forEach(file => {
          dispatch('setFile', { file, tab })
        })
        commit('setNextToken', { token: nextToken, tab })
        if (!state[tab].timestamp) {
          commit('setTimestamp', tab)
        }
        commit('setBusy', { tab, busy: false })
      })
      .catch(() => {
        commit('setBusy', { tab, busy: false })
        Message({
          type: 'error',
          message: 'Oops, we were unable to fetch your files',
          showClose: true
        })
      })
  },
  getUpdates ({ state, commit, dispatch }, { tab, token }) {
    if (!state[tab].timestamp) {
      dispatch('getFiles', { tab })
      return
    }
    // media getter require to send no 'type' param for getting all types
    const type = tab === 'all' ? undefined : tab
    const timestamp = state[tab].timestamp
    apiMedia
      .getMediaFiles({ type, token, timestamp, pageSize: PAGE_SIZE })
      .then(ItemService.decodeItems)
      .then(({ items, nextToken }) => {
        items.forEach(file => {
          dispatch('setFile', { file, tab })
        })
        if (nextToken && nextToken !== token) {
          dispatch('getUpdates', { tab, token: nextToken })
        } else {
          commit('setTimestamp', tab)
        }
      })
      .catch(() => {
        Message({
          type: 'error',
          message: 'Oops, we were unable to fetch updates',
          showClose: true
        })
      })
  },
  setFile ({ commit }, { file, tab }) {
    tab = tab || properTab(file.type)
    if (!tab) return

    if (file.status === 2) {
      commit('removeFile', { file, tab })
      if (tab !== 'all') commit('removeFile', { file, tab: 'all' })
    } else {
      commit('setFile', { file, tab })
      if (tab !== 'all') commit('setFile', { file, tab: 'all' })
    }
  },
  removeFile ({ commit }, { file, tab }) {
    tab = tab || properTab(file.type)
    if (!tab) return

    commit('removeFile', { file, tab })
    if (tab !== 'all') commit('removeFile', { file, tab: 'all' })
  }
}

const mutations = {
  setBusy (state, { tab, busy }) {
    Vue.set(state[tab], 'busy', busy)
  },
  setActiveTab (state, tab) {
    Vue.set(state, 'activeTab', tab)
  },
  setFile (state, { file, tab }) {
    const fileIndex = state[tab].files.findIndex(f => {
      return f.id === file.id
    })

    if (fileIndex > -1) {
      state[tab].files.splice(fileIndex, 1)
    }
    state[tab].files.push(file)
  },
  removeFile (state, { file, tab }) {
    const fileIndex = state[tab].files.findIndex(f => {
      return f.id === file.id
    })

    if (fileIndex > -1) {
      state[tab].files.splice(fileIndex, 1)
    }
  },
  setNextToken (state, { token, tab }) {
    if (state[tab].nextToken !== token) {
      Vue.set(state[tab], 'nextToken', token)
    }
  },
  setTimestamp (state, tab) {
    const timestamp = new Date().getTime()
    Vue.set(state[tab], 'timestamp', timestamp)
  }
}

function properTab (type) {
  switch (type) {
    case 1:
      return 'audio'
    case 2:
      return 'video'
    case 3:
      return 'photo'
    default:
      return undefined
  }
}

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
